import {observable} from 'mobx';

export default class ElementModel {
    constructor(icon, position, type, text='', reaction='none', starRating=0) {
        this.uuid = this.uuid();
        this.icon = icon;
        this.text = text;
        this.type = type;
        this.reaction = reaction;
        this.position = position;
        this.starRating = starRating;
    }

    @observable text = null;
    @observable reaction = null;
    @observable starRating = null;
    @observable position = null;

    icon = null;

    uuid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }
}


// WEBPACK FOOTER //
// ./src/models/ElementModel.js